
import { RouteEntity, TeamResultIntermiadiate } from "@/interfaces";
import CompetitionService from "@/services/CompetitionService";
import { computed, defineComponent, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { MrUiKitBlob } from "mr-ui-kit";

import EntityBlock from "@/components/Frontend/TeamResult/EntityBlock.vue";
import IntermiadiateBlock from "@/components/Frontend/TeamResult/IntermiadiateBlock.vue";
import Spinner from "@/components/UI/Spinner.vue";

export default defineComponent({
  name: "TeamResultIntermiadiate",
  components: {
    EntityBlock,
    IntermiadiateBlock,
    Spinner,
    MrUiKitBlob,
  },
  props: {
    id: {
      type: Number,
      default: -1,
    },
    generalNotes: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    const { t, locale } = useI18n();
    const isLoading = ref<boolean>(false);
    const showBlob = ref(false);
    const intermiadiate = ref<TeamResultIntermiadiate | null>(null);

    onMounted(async () => {
      isLoading.value = true;
      if (props.id !== -1) {
        intermiadiate.value = await CompetitionService.getIntermiadiatesById(
          props.id,
          locale.value
        );
      }
      isLoading.value = false;
    });

    const blobFiles = computed(() => {
      return intermiadiate.value?.attachments.map((a) => {
        return {
          src: a.original,
          type: isPdf(a.url) ? "pdf" : "image",
        };
      });
    });

    const isPdf = (file: string) => {
      return file.indexOf(".pdf") > 0;
    };

    return {
      t,
      isPdf,
      blobFiles,
      showBlob,
      isLoading,
      intermiadiate,
      trainerEntity: RouteEntity.Trainer,
      athleteEntity: RouteEntity.Athlete,
    };
  },
});
